import { render, staticRenderFns } from "./SalariesTableView.vue?vue&type=template&id=6dc71d9e&scoped=true"
import script from "./SalariesTableView.vue?vue&type=script&lang=js"
export * from "./SalariesTableView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc71d9e",
  null
  
)

export default component.exports